import log from '$lib/utils/log';
import type { HandleClientError } from '@sveltejs/kit';

export const handleError: HandleClientError = async ({ error }) => {
	log.scope('Hooks - Client').exception(error);
};
